import {Link, Navigate, useNavigate, useParams} from "react-router-dom";
import HeaderCard from "../../components/tosan/HeaderCard";
import ContentWrapper from "../../components/tosan/ContentWrapper";

import {useContext, useEffect, useState} from "react";
import DataContext from "../../tools/contexts/tosan/DataContext";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'
import Button from "../../components/newComponents/button/Button";
import getBills from "../../tools/api/tosan/getBills";
import UserBills from "../../components/tosan/UserBills"
import BillTypes from "../../tools/defaults/tosan/billTypes";
import useAxiosCancel from "../../tools/hoc/useAxiosCancel";
import BottomButtonWrapper from "../../components/BottomButtonWrapper";


const BillList = () => {
    const params = useParams();
    const {serviceType} = params;
    const navigate = useNavigate();
    const dataContext = useContext(DataContext);
    const [loading, setLoading] = useState(true);
    const [bills, setBills] = useState(null);
    const getCancelToken=useAxiosCancel();

    useEffect(() => {
        handleGetBills({bill_type:BillTypes[serviceType].billType}).then(r => {})

    }, [])
    const handleGetBills = async (params) => {
        setLoading(true);
        const cancelToken=getCancelToken();
        const response = await getBills(dataContext.token, params,cancelToken);

        setLoading(false)
        if (response.isOk) {
            setBills([...response.data]);
        } else {

        }
    }
    const handleBack = () => {
        navigate('/tosan')
    }
    if (!BillTypes[serviceType]) {
        return <Navigate to={'/notfound'}/>
    }

    return <div className="min-h-screen bg-white">
        <HeaderCard hasBack={false} onBack={handleBack}
                    className={`flex justify-center ${serviceType}-header-card flex-col items-center  ${serviceType}`}>
            <h1 className="title">{BillTypes[serviceType].title}</h1>
        </HeaderCard>

        <ContentWrapper className="pt-5 content-wrapper-height">
            {loading && <Skeleton height={65} baseColor={"#ededed"} count={3}/>}
            {!loading && bills&& <UserBills type={serviceType} key={bills.toString()} bills={bills} handleGetBills={()=>handleGetBills({bill_type:BillTypes[serviceType].billType})} />}
            <BottomButtonWrapper grid={2}>
                <Button  rounded="rounded" theme="link" onClick={handleBack}>بازگشت</Button>
                <Link className="w-full" to={"/tosan/addBill/" + serviceType}>
                    <Button className="w-full" size="normal" rounded="rounded">افزودن قبض </Button>
                </Link>
            </BottomButtonWrapper>

        </ContentWrapper>
    </div>
}
export default BillList;